module.exports = __webpack_public_path__ + "static/media/nd7.40570e6f.webp";